interface TextLogoProps {
  variant?: "horizontal" | "stacked" | "compact";
  size?: "sm" | "md" | "lg" | "xl";
  className?: string;
}

const horizontalSizes = {
  sm: "text-sm",
  md: "text-base",
  lg: "text-xl",
  xl: "text-2xl",
} as const;

const stackedAiSizes = {
  sm: "text-2xl",
  md: "text-3xl",
  lg: "text-4xl",
  xl: "text-4xl md:text-5xl",
} as const;

const stackedTextSizes = {
  sm: "text-base",
  md: "text-xl",
  lg: "text-2xl",
  xl: "text-2xl md:text-3xl",
} as const;

const badgeSizes = {
  sm: "px-1.5 py-0.5 text-[11px]",
  md: "px-2 py-0.5 text-xs",
  lg: "px-2.5 py-1 text-sm",
  xl: "px-3 py-1 text-base",
} as const;

export function TextLogo({
  variant = "horizontal",
  size = "md",
  className,
}: TextLogoProps): JSX.Element {
  if (variant === "stacked") {
    return (
      <div
        className={cx(
          "text-center font-extrabold leading-tight tracking-tight text-text-primary",
          className,
        )}
      >
        <div className={cx("text-primary", stackedAiSizes[size])}>AI</div>
        <div className={cx("mt-1 tracking-wide", stackedTextSizes[size])}>
          不動産案件 OS
        </div>
      </div>
    );
  }

  if (variant === "compact") {
    return (
      <div
        className={cx(
          "inline-flex items-center gap-1.5 font-extrabold tracking-tight text-text-primary",
          horizontalSizes[size],
          className,
        )}
      >
        <LogoBadge size={size} />
        <span>OS</span>
      </div>
    );
  }

  return (
    <div
      className={cx(
        "inline-flex items-center gap-2 font-extrabold tracking-tight text-text-primary",
        horizontalSizes[size],
        className,
      )}
    >
      <LogoBadge size={size} />
      <span>不動産案件 OS</span>
    </div>
  );
}

function LogoBadge({ size }: { size: NonNullable<TextLogoProps["size"]> }): JSX.Element {
  return (
    <span
      className={cx(
        "inline-flex items-center rounded bg-primary font-extrabold leading-none text-white",
        badgeSizes[size],
      )}
    >
      AI
    </span>
  );
}

function cx(...classes: Array<string | false | undefined>): string {
  return classes.filter(Boolean).join(" ");
}
